import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { getGalleryCategories } from "./galleryApi";

function GalleryCategory() {
  const [categories, setCategories] = useState([]);

  const handleFooterLink = () => {
    window.scrollTo(0, 0);
  };

  // ✅ SAME useEffect (no change)
  useEffect(() => {
    getGalleryCategories()
      .then((res) => setCategories(res.data.data))
      .catch((err) => console.log(err));
  }, []);

  return (
    <Wrapper>
      <div className="container" id="about">
        {/* ✅ SAME TITLE */}
        <h1 className="text-center">
          Welcome to Aysuhi Construction Gallery Page
        </h1>

        {/* ✅ SAME UNDERLINE */}
        <div
          className="underline mx-auto"
          style={{
            height: 3,
            width: "4rem",
            backgroundColor: "#34495E",
            marginTop: 20,
            marginBottom: 20,
          }}
        ></div>

        {/* ✅ SAME GRID + CARD DESIGN */}
        <div className="row">
          {categories.map((cat) => (
            <div key={cat.id} className="col-md-6 mb-4">
              <div className="card shadow">
                <img
                  src={`https://ayushiconstruction.com/public/uploads/${cat.thumbnail_image}`}
                  className="card-img-top"
                  alt={cat.title}
                  style={{ height: "300px", objectFit: "cover" }}
                />

                <div className="card-body text-center">
                  <h5 className="card-title">{cat.title}</h5>

                  <Link
                    to={`/gallery-category/${cat.id}`}
                    onClick={handleFooterLink}
                    className="btn"
                  >
                    View Images
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  );
}

export default GalleryCategory;

// ✅ EXACT SAME STYLES (NO CHANGE)
const Wrapper = styled.div`
  h1 {
    color: #f26a20;
  }

  #about {
    margin-top: 2.5rem;

    @media screen and (max-width: 768px) {
      margin-top: 1rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      margin-top: 1rem;
    }
  }

  .btn {
    background-color: #f26a18;
    color: white;
  }
`;
